import { useEffect, useState } from 'react';

export default function useScreenType() {
  const getDeviceType = () => {
    const width = window.innerWidth;
    return {
      isMobile: width <= 576,
      isTablet: width > 576 && width <= 991,
      isDesktop: width > 991
    };
  };

  const [screen, setScreen] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setScreen(getDeviceType());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screen;
}
